import React, { createContext, useEffect, useState } from 'react';

export const TimeContext = createContext<Date | null>(null);

export function TimerProvder({ children }: React.PropsWithChildren<{}>) {
    const [time, setTime] = useState(new Date());

    useEffect(() => {
        const interval = setInterval(() => {
            // This will trigger a re-render every second
            setTime(new Date());
        }, 1000);

        return () => clearInterval(interval);
    }, []);

    return <TimeContext.Provider value={time}>{children}</TimeContext.Provider>;
}
